import { defaultApi } from '@/api';
import { AccountSettingsFormState } from '@/features/accountSettings/types/accountSettings';

export async function updateAccount({ formData }: { formData: AccountSettingsFormState }) {
  const { data } = await defaultApi.put('/update-account', { ...formData });
  return data;
}
